import React from 'react';
import { i18n } from 'utils/i18n';
import { dtm } from 'utils/analytics';
import Button from 'components/Button';
import { ANALYTICS } from 'constants';
import propTypes from './modifyResBannerPropTypes';

const ModifyResBanner = ({ handleExitModify, breakpoint }) => (
  <div className='modify-res-banner modify-res-banner__container'>
    {!breakpoint.isMobile && <div className='modify-res-banner__content'>{i18n('modify_reservation_banner_copy')}</div>}
    <Button
      link
      data-dtm-track={dtm(ANALYTICS.UI_BUTTON, ANALYTICS.MODIFY, 'exit_without_modifying')}
      className='modify-res-banner__edit-btn'
      onClick={handleExitModify}
    >
      {i18n('modify_reservation_exit_modify_button')}
    </Button>
  </div>
);

ModifyResBanner.propTypes = propTypes;

export default ModifyResBanner;
